// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon_2Dnsm","carousel":"index_carousel_3FMuk"};